<template>
  <v-dialog
    v-model="showModal"
    max-width="400"
    attach="body"
  >
    <v-card
      class="mx-auto"
      light
      color="#ECEFF1"
    >
      <v-toolbar
        color="#37474F"
        dark
      >
        <v-toolbar-title>
          {{ title }}
        </v-toolbar-title>
      </v-toolbar>
      <v-card-text>
        <p class="message-style">
          {{ message }}
        </p>
        <v-card-actions
          v-if="!downloadPopUp"
          class="p-0"
        >
          <v-spacer />
          <v-btn
            color="green darken-1"
            text
            @click="showModal = false"
          >
            {{ cancelButton }}
          </v-btn>
          <v-btn
            color="red darken-1"
            text
            @click="$emit('confirmed')"
          >
            {{ confirmButton }}
          </v-btn>
        </v-card-actions>
        <v-card-actions
          v-else
          class="p-0"
        >
          <div v-if="isIOS || isAndroid">
            <a @click.prevent="handleClick()">
              <img
                v-if="isIOS"
                src="../../assets/img/appstore.png"
                alt=""
                width="120px"
              ></a> <a @click="handleClickAndroid"><img
              v-if="isAndroid"
              src="../../assets/img/playstore.png"
              width="120px"
            ></a> <br> <span class="ml-2 mr-2">or
            </span> <br><v-btn  @click="$emit('closed')">Continue on web</v-btn>
          </div>
          <div v-else>
            <a @click.prevent="handleClick()"><img
              src="../../assets/img/appstore.png"
              alt=""
              width="120px"
              class="mr-2"
            ></a> <a @click="handleClickAndroid"><img
              src="../../assets/img/playstore.png"
              width="120px"
            ></a> <br> <span
              class="ml-2 mr-2"
            >or </span><br><v-btn @click="$emit('closed')">
              Continue on web
            </v-btn>
          </div>
        </v-card-actions>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: 'AlertDialog',
  props: {
    title: {
      type: String,
      default: 'Confirm Log out',
    },
    message: {
      type: String,
      default: 'Are you sure you want to log out ?',
    },
    cancelButton: {
      type: String,
      default: 'No',
    },
    confirmButton: {
      type: String,
      default: 'Yes',
    },
    downloadPopUp: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    showModal: true,
    isIOS: /iPad|iPhone|iPod/.test(navigator.userAgent),
    isAndroid: /Android/.test(navigator.userAgent),
  }),
  watch: {
    showModal: function (newval, oldval) {
      if (newval === false) {
        this.$emit('closed');
      }
    },
  },
  methods: {
    async clickData (isIOS) {
      await this.$store
        .dispatch('alert/clickDataAnalytics', {
          type: isIOS,
        })
        .then(() => {
        });
    },
    handleClick () {
      this.clickData('ios');

      window.open(
        'https://apps.apple.com/us/app/swift-checkin-construction-app/id6755225256',
        '_blank',
      );
    },
    handleClickAndroid () {
      this.clickData('android');
      window.open(
        'https://play.google.com/store/apps/details?id=com.swiftcheckin.app',
        '_blank',
      );
    },
  },
};
</script>
<style scoped>
.message-style {
  margin-top: 25px;
  font-weight: 500;
  color: #455A64;
  font-size: 16px;
}

.v-card__actions {
  padding: 0px !important;
}
</style>
